import { render, staticRenderFns } from "./ListProduct.vue?vue&type=template&id=db02ab62&scoped=true&"
import script from "./ListProduct.vue?vue&type=script&lang=ts&"
export * from "./ListProduct.vue?vue&type=script&lang=ts&"
import style0 from "./ListProduct.vue?vue&type=style&index=0&id=db02ab62&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../namtrung_logistics/client/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db02ab62",
  null
  
)

export default component.exports